 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","about-us":"about-us","article~contest~project~project-edit~project-new":"article~contest~project~project-edit~project-new","article":"article","project~project-edit~project-new":"project~project-edit~project-new","project":"project","contact":"contact","contests~profile":"contests~profile","contests":"contests","contest~profile~project-edit~project-new~projects~sign-up":"contest~profile~project-edit~project-new~projects~sign-up","contest":"contest","project-edit~project-new~sign-up":"project-edit~project-new~sign-up","project-edit":"project-edit","project-new":"project-new","profile":"profile","sign-in~sign-up":"sign-in~sign-up","sign-up":"sign-up","projects":"projects","introduction":"introduction","learn":"learn","my-profile":"my-profile","news":"news","reset-password":"reset-password","setup-new-password":"setup-new-password","sign-in":"sign-in","sign-up-success":"sign-up-success","thank-you-for-sharing-your-project":"thank-you-for-sharing-your-project","thank-you-for-subscribing":"thank-you-for-subscribing"}[chunkId]||chunkId) + "." + {"404":"d1f4dc35","about-us":"62a135ac","article~contest~project~project-edit~project-new":"aa4fb010","article":"d4577134","project~project-edit~project-new":"32b20b89","project":"edd0b671","contact":"32950f05","contests~profile":"3677f6e1","contests":"3b7373f4","contest~profile~project-edit~project-new~projects~sign-up":"892ea779","contest":"1607c20b","project-edit~project-new~sign-up":"1ae82a60","project-edit":"ec3b2852","project-new":"9140f5e6","profile":"c3962d64","sign-in~sign-up":"eb85e1da","sign-up":"2765251e","projects":"efd494d9","introduction":"f5885774","learn":"0ce05bb6","my-profile":"4c36156d","news":"c9489859","reset-password":"b1aee66d","setup-new-password":"74ddcc1c","sign-in":"52516973","sign-up-success":"0f2f59e1","thank-you-for-sharing-your-project":"f78e445c","thank-you-for-subscribing":"16e140fb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about-us":1,"article~contest~project~project-edit~project-new":1,"article":1,"project~project-edit~project-new":1,"project":1,"contact":1,"contests~profile":1,"contests":1,"contest~profile~project-edit~project-new~projects~sign-up":1,"contest":1,"project-edit~project-new~sign-up":1,"project-edit":1,"project-new":1,"profile":1,"sign-in~sign-up":1,"sign-up":1,"reset-password":1,"setup-new-password":1,"sign-up-success":1,"thank-you-for-sharing-your-project":1,"thank-you-for-subscribing":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","about-us":"about-us","article~contest~project~project-edit~project-new":"article~contest~project~project-edit~project-new","article":"article","project~project-edit~project-new":"project~project-edit~project-new","project":"project","contact":"contact","contests~profile":"contests~profile","contests":"contests","contest~profile~project-edit~project-new~projects~sign-up":"contest~profile~project-edit~project-new~projects~sign-up","contest":"contest","project-edit~project-new~sign-up":"project-edit~project-new~sign-up","project-edit":"project-edit","project-new":"project-new","profile":"profile","sign-in~sign-up":"sign-in~sign-up","sign-up":"sign-up","projects":"projects","introduction":"introduction","learn":"learn","my-profile":"my-profile","news":"news","reset-password":"reset-password","setup-new-password":"setup-new-password","sign-in":"sign-in","sign-up-success":"sign-up-success","thank-you-for-sharing-your-project":"thank-you-for-sharing-your-project","thank-you-for-subscribing":"thank-you-for-subscribing"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","about-us":"446179c0","article~contest~project~project-edit~project-new":"658404a5","article":"cab59e1c","project~project-edit~project-new":"ae25dd88","project":"cab59e1c","contact":"70d9c33e","contests~profile":"9cbd075f","contests":"11dddc7e","contest~profile~project-edit~project-new~projects~sign-up":"4cdc6745","contest":"a3c8b984","project-edit~project-new~sign-up":"2090ba31","project-edit":"4bde2374","project-new":"4bde2374","profile":"2900e2e9","sign-in~sign-up":"cc39a4e3","sign-up":"c40cc259","projects":"31d6cfe0","introduction":"31d6cfe0","learn":"31d6cfe0","my-profile":"31d6cfe0","news":"31d6cfe0","reset-password":"aad21bc7","setup-new-password":"0f0cedac","sign-in":"31d6cfe0","sign-up-success":"5558798b","thank-you-for-sharing-your-project":"7285147e","thank-you-for-subscribing":"0f0cedac"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
